// extracted by mini-css-extract-plugin
export default {"root":"WaPYR","avatar":"_2DfVy"};